const TypeTest = {
    TECHNICAL: "QA technical training",
    THEORY: "Testing theory",
  };
  
  
  module.exports = { TypeTest };
  